import { render, staticRenderFns } from "./pnrDetail.vue?vue&type=template&id=6fc258ad&scoped=true&"
import script from "./pnrDetail.vue?vue&type=script&lang=js&"
export * from "./pnrDetail.vue?vue&type=script&lang=js&"
import style0 from "./pnrDetail.vue?vue&type=style&index=0&id=6fc258ad&prod&lang=less&scoped=true&"
import style1 from "./pnrDetail.vue?vue&type=style&index=1&id=6fc258ad&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc258ad",
  null
  
)

export default component.exports